import { VContainer } from 'vuetify/lib/components/VGrid';
import { VFlex } from 'vuetify/lib/components/VGrid';

var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(VContainer,{attrs:{"fill-height":"","fluid":"","grid-list-xl":""}},[_c(VFlex,[_c('app-upsert',{attrs:{"title":"New Lost","config":_vm.config,"item":_vm.lost,"api-upsert":_vm.apiSave},on:{"saved":_vm.saved}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }